import { H2, Columns } from "atoms";
import { ReviewableCard } from "features/reviewable";
import { useReviewableList } from "features/search";

function FeaturedArtists() {
  const { data } = useReviewableList("artist-of-the-month");

  return (
    <>
      <H2>Featured Artists</H2>

      {data && (
        <Columns cols={4}>
          {data.data.map((artist) => (
            <ReviewableCard entity={artist} key={artist.id} />
          ))}
        </Columns>
      )}
    </>
  );
}

export { FeaturedArtists };
